var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('InvoicesSummary',{attrs:{"invoices":_vm.invoices,"showDetail":_vm.showDetail,"detailed":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }